/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "cash": {
        "nested": {
          "gambit": {
            "nested": {
              "api": {
                "nested": {
                  "v1": {
                    "nested": {
                      "common": {
                        "nested": {
                          "Tenant": {
                            "values": {
                              "TENANT_UNSPECIFIED": 0,
                              "TENANT_CASH_APP": 1,
                              "TENANT_CASH_APP_V2_ENSENTA": 3,
                              "TENANT_CASH_APP_V2O_ENSENTA": 6,
                              "TENANT_SQUARE_BANKING": 2,
                              "TENANT_SQUARE_BANKING_V2_ENSENTA": 4,
                              "TENANT_SQUARE_BANKING_V2O_ENSENTA": 7,
                              "TENANT_SQUARE_INVOICES": 5,
                              "TENANT_SQUARE_INVOICES_V2O_ENSENTA": 8
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.cash?.nested?.gambit?.nested?.api?.nested?.v1?.nested?.common?.nested?.Tenant) {
  $root.addJSON(jsonData);
}

/**
 * next id: 9
 *
 * This proto enum is used so that Gambit tenants (services and products that
 * call Gambit's APIs) can differentiate their check deposits when Gambit
 * publishes events.
 *
 * SOURCE Tenant @ squareup/cash/gambit/api/v1/common/tenant.proto at 24:1
 */
export const Tenant = $root.lookupEnum('squareup.cash.gambit.api.v1.common.Tenant').values;